import React, { useEffect } from 'react';
import { wire } from 'react-hot-wire';
import { useQuery } from 'react-query';
import queryString from 'query-string';
import Loader from 'components/commons/_/loader/Loader';

/**
 * TODO: make this into route component or into onEntry hook, once
 * TODO: a) react-router is upgraded (route component)
 * TODO: b) router is no longer initiating the whole application, and instead first application is loaded, and THEN any
 * TODO:    routing is done, able to authorize users (onEntry hook)
 */
const AnonymousOnly = props => {
	const userDetailsQuery = useQuery({
		queryFn: () => props['services.userService'].fetchDetails(),
	});

	useEffect(() => {
		const { returnUrl, ...rest } = queryString.parse(window.location.search);

		// only when present - e.g. the OAuth callback lands back here without the param and must not wipe the stored value:
		if (returnUrl) {
			props['services.returnUrlService'].capture(returnUrl);

			// it now lives in storage - drop it from the visible url so the deep link is not left in the address bar / history:
			const search = queryString.stringify(rest);

			props['services.navigationService'].replace(window.location.pathname + (search ? `?${search}` : ''));
		}
	}, []);

	useEffect(() => {
		if (!userDetailsQuery.isLoading && props['services.userService'].isNonAnonymous()) {
			const returnUrl = props['services.returnUrlService'].pickUp();

			if (returnUrl) {
				// replace, not push - a Back press must not land on the login page and get forwarded again:
				props['services.navigationService'].loadReplace(returnUrl);
			} else {
				props['services.navigationService'].replace('/');
			}
		}
	}, [userDetailsQuery.isLoading]);

	if (userDetailsQuery.isLoading) {
		return <Loader />;
	}

	if (props['services.userService'].isNonAnonymous()) {
		return null;
	}

	return <React.Fragment>{props.children}</React.Fragment>;
};

export default wire(['services.navigationService', 'services.userService', 'services.returnUrlService'], AnonymousOnly);
